import { Model } from './model';
import type dayjs from 'dayjs';
import { TransformStringToDayJS } from './utils';

export class DisputeReason extends Model {
  id: string;

  auto_activate_guidelines: string | null;

  auto_dispute_activate: boolean;

  auto_dispute_routing: boolean;

  auto_routing_emails: string[];

  code: string;

  custom_fields: string;

  custom_object_type: string;

  description: string;

  is_active: boolean;

  @TransformStringToDayJS()
  last_synced_at: dayjs.Dayjs;

  name: string;

  @TransformStringToDayJS()
  remote_created_at: dayjs.Dayjs;

  remote_id: string;

  remote_metadata: string;

  @TransformStringToDayJS()
  remote_modified_at: dayjs.Dayjs;

  sync_status: string;
}

export interface SuggestedDisputeReason {
  code: string;

  description: string;

  name?: string;

  object: string;
}
